import { PaginationPropsMicrocopy } from '../../molecules/Pagination';
import { ReportReviewModalData } from '../ReportReviewModal';
import {
  UserProductReviewPropsData,
  UserProductReviewPropsMicrocopy,
} from '../UserProductReview';

export const enum ProductReviewFilterValues {
  DEFAULT = '',
  ONE_STAR = '1',
  TWO_STARS = '2',
  THREE_STARS = '3',
  FOUR_STARS = '4',
  FIVE_STARS = '5',
}

export type ProductReviewFilterOptions = {
  label: string;
  value: ProductReviewFilterValues;
};

export const enum ProductReviewSortByValues {
  MOST_RECENT = 'most-recent',
  RELEVANCY = 'relevancy',
  HELPFULNESS = 'helpfulness',
}

export type ProductReviewSortByOptions = {
  label: string;
  value: ProductReviewSortByValues;
};

export type ProductReviewsPropsMicrocopy = UserProductReviewPropsMicrocopy & {
  reviews: string;
  filters: string;
  sortBy: string;
  filterOptions: string[];
  sortOptions: string[];
  results: string;
  rating: string;
  mostRecent: string;
  helpfulness: string;
  pagination: PaginationPropsMicrocopy;
  emptyState?: {
    title: string;
    description: string;
    cta?: string;
  };
};

export type ProductReviewsPropsData = {
  reviews: UserProductReviewPropsData[];
  start: number;
  end: number;
  total: number;
  currentPage: number;
  totalPages: number;
};

export type ProductReviewsPropsActions = {
  onHelpfulVotesReview: (reviewId: string) => void;
  onEditReview: (reviewId: string) => void;
  onDeleteReview: (reviewId: string) => void;
  onHelpfulVotesReply: (replyId: string) => void;
  onEditReply: (replyId: string) => void;
  onDeleteReply: (replyId: string) => void;
  onSubmitReply: (reply: string, replyId?: string) => void;
  onFilter: (filter: string) => void;
  onSort: (sort: string) => void;
  onPageChange: (page: number) => void;
  onSubmitReport: (data: ReportReviewModalData) => void;
  onClickEmptyStateCta?: () => void;
};

export type ProductReviewsPropsDataWithMicrocopy = {
  microcopy: ProductReviewsPropsMicrocopy;
} & ProductReviewsPropsData;

export type ProductReviewsProps = ProductReviewsPropsDataWithMicrocopy &
  ProductReviewsPropsActions & {
    className?: string;
  };
